import React, { useState, useEffect, useRef } from "react";
import { Dropdown, Form } from "react-bootstrap";
import { FiChevronDown } from "react-icons/fi";
import { PayrollRevision } from "../Services/PayrollRevision";
import { UserManagement } from "../Services/UserManagement";

interface Tenant {
  tenantid: number;
  tenantname: string;
  status: string;
}

const TenantDropdown: React.FC<any> = ({ disabled, onTenantChange }) => {
  const toggleRef = useRef<any>(null);
  const [selectedTenant, setSelectedTenant] = useState<Tenant>({
    tenantid: -1, // Fixed: Changed "id" to "tenantid"
    tenantname: "",
    status: "",
  });

  const [tenantSearch, setTenantSearch] = useState<string>("");
  const [isTenantLoading, setIsTenantLoading] = useState<boolean>(false);
  const [tenantsList, setTenantsList] = useState<Tenant[]>([]);
  const [filterTenantList, setFilterTenantList] = useState<Tenant[]>([]);
  const tenantSelector = useRef<HTMLDivElement>(null);

  useEffect(() => {
    getTenantsList();
  }, []);

  const getTenantsList = async () => {
    setIsTenantLoading(true);
    try {
      const result = await PayrollRevision.GetTenantList();
      const data: Tenant[] = result?.result?.result || [];
      const activeTenants = data.filter(
        (item) => item.status.toLowerCase() === "active"
      );
      setTenantsList(activeTenants);
      setFilterTenantList(activeTenants);
    } catch (error) {
      console.error("Error fetching tenants:", error);
    } finally {
      setIsTenantLoading(false);
    }
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.toLowerCase().trim();
    setTenantSearch(value);
    setFilterTenantList(
      value
        ? tenantsList.filter((tenant) =>
            tenant.tenantname.toLowerCase().includes(value)
          )
        : tenantsList
    );
  };

  const handleTenantChange = (tenant: Tenant) => {
    setSelectedTenant(tenant);
    onTenantChange(tenant);
  };

  const tenantDDToggle = () => {
    setTimeout(() => {
      $("#idTenantSearch").focus();
    }, 50);
  };

  const onTabKeyDown = (e) => {
    e.preventDefault();
    if (
      toggleRef?.current &&
      toggleRef?.current.ariaExpanded === "false" &&
      e?.keyCode === 9
    ) {
      toggleRef?.current?.click();

      tenantDDToggle();
    }
  };

  return (
    <div className="d-flex headerDownControl">
      <div className="ePayTenantSelector">
        <label>Tenant</label>
        <div className="d-flex">
          <Dropdown
            tabIndex={0}
            onKeyUp={(e) => onTabKeyDown(e)}
            className={`${
              isTenantLoading || disabled ? "disabled-area" : ""
            } ePayTenantSelectorDropdown`}
            onToggle={tenantDDToggle}
            onClick={tenantDDToggle}
          >
            <Dropdown.Toggle
              ref={toggleRef}
              disabled={disabled}
              className="ePayButton"
              id="dropdown-Tenant"
            >
              <div className="d-flex align-items-center justify-content-center">
                <div>
                  {selectedTenant.tenantid !== -1
                    ? selectedTenant.tenantname
                    : "Select Tenant"}
                </div>
                <div className="ml-auto drop-arrow d-flex">
                  <FiChevronDown />
                </div>
              </div>
            </Dropdown.Toggle>
            <Dropdown.Menu
              className="ePayTenantSelectorMenu"
              ref={tenantSelector}
            >
              <div className="ePayTenantSearch">
                <Form.Group controlId="ePayTenantSearch">
                  <Form.Control
                    id="idTenantSearch"
                    type="text"
                    name="search"
                    value={tenantSearch}
                    autoComplete="off"
                    onChange={handleSearch}
                    placeholder="Search Tenant"
                    autoFocus={true}
                  />
                </Form.Group>
              </div>
              <div className="dropdownItems">
                {filterTenantList.length > 0 ? (
                  filterTenantList.map((tenant) => (
                    <Dropdown.Item
                      key={tenant.tenantid}
                      className={
                        selectedTenant.tenantid === tenant.tenantid
                          ? "active"
                          : ""
                      }
                      onClick={() => handleTenantChange(tenant)}
                    >
                      {/* <div className="d-flex align-items-center justify-content-center"> */}
                      <div>
                        <div>{tenant.tenantname}</div>
                      </div>
                    </Dropdown.Item>
                  ))
                ) : (
                  <Dropdown.Item>No Item Found</Dropdown.Item>
                )}
              </div>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </div>
  );
};

export default TenantDropdown;
